import React, { FC } from 'react';
import { useRouter } from 'next/router';
import useTranslations from '@hooks/useTranslations';
import TopNavbar from '@components/TopNavbar';
import { BRAND } from 'src/services/core/sdk/constants/sdkFields';
import { BrandTypes } from '../../../types/brands';
import { MyAccountBreadcrumbs } from '@components/MyAccountBreadcrumbs';
import { IMyAccountControllerProps } from './index';
import {isBrandAP, isBrandDS} from '../../../constants/main';

export const MyAccountControllerTemplate: FC<IMyAccountControllerProps> = ({
    className,
    children,
    title,
}: IMyAccountControllerProps) => {
    const { t } = useTranslations();
    const router = useRouter();
    return (
        <div className={className}>
            {!isBrandAP && !isBrandDS && (
                <TopNavbar
                    title={title ? title : t('header.nav.myAccount')}
                    className={`my-account-topnavbar ${BRAND === BrandTypes.DS && 'dark'}`}
                    onGoBack={() => {
                        router.push('/');
                    }}
                />
            )}
            <div className="my-account-page">
                <div className="my-account-content">
                    <MyAccountBreadcrumbs className="my-account-breadcrumbs" />
                    <p className="my-account-content-title">{t('header.nav.myAccount')}</p>
                    {children}
                </div>
            </div>
        </div>
    );
};
